import React, { useEffect, useState } from 'react';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import ReviewTopicPlot from '../ReviewTopicPlot';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTopicFiltersData } from '../../../../actions/fetchOverViewData';
import { parseFilters } from '../../../../../Filters/utils/fetchData';
import SidebarLoader from './SidebarLoader';
import { useLocation, useHistory } from 'react-router-dom';

const SidebarContent = props => {
  const { selectedCardData, selectedCardId, setSelectedCardId } = props;
  const [cstTopicData, setcstTopicData] = useState({});
  const [loading, setLoading] = useState(false);
  const { applied_filters } = useSelector(e => e.filterReducer);

  const { applied_filter_values } = useSelector(e => e?.filterReducer);

  const location = useLocation();

  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (selectedCardId) {
      fetchData(selectedCardId);
    }
  }, [selectedCardId]);

  // history.push(`${location.pathname}?${newQuery}`);

  function fetchData(clickedChartPageType) {
    const filters = parseFilters(applied_filter_values);
    setLoading(true);
    dispatch(
      fetchTopicFiltersData({
        filters,
        pageType: clickedChartPageType,
        onSuccess: e => {
          setLoading(false);
          setcstTopicData(e);
          setSelectedCardId(null);
        },
        onError: () => {
          setLoading(false);
        }
      })
    );
  }

  function onTopicClick(e) {
    const appliedFilterValues = { ...applied_filter_values, topics_filter: [[e]] };

    const stringified = encodeURIComponent(JSON.stringify(appliedFilterValues));
    history.push(`/dashboard/feedback?filters=${stringified}`);
  }

  if (loading) {
    return <SidebarLoader />;
  }
  return (
    <MultiFeatureCard
      title={cstTopicData?.title}
      subTitle={selectedCardData?.subTitle}
      enableSwitchTab={cstTopicData?.enableSwitchTab}
      // switchOptions={cstTopicData?.switchOptions}
      switchOptions={['TABLE', 'BAR']}
      renderContent={(activeSwitch, contentRef) => {
        return (
          <ReviewTopicPlot
            onTopicClick={onTopicClick}
            type={activeSwitch}
            widgetData={cstTopicData}
            itemData={cstTopicData?.cstData}
            contentRef={contentRef}
          />
        );
      }}
    />
  );
};






export default SidebarContent;
